import { createContext } from 'react'

/**
 * @type {import('react').Context<{ isEnabled: (key: string) => boolean }>}
 */

export const FeatureToggleContext = createContext()
